import { Directive, ElementRef, Input } from "@angular/core";

@Directive({
  selector: "[autofocus]"
})
export class AutofocusDirective {
  private focus = true;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    if (this.focus) {
      window.setTimeout(() => {
        this.el.nativeElement.focus()
      }, 10);
    }
  }

  @Input() set autofocus(condition: boolean) {
    this.focus = condition !== false
  }
}